import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

export interface CriteriaThemeProps {
  minHeight?: string;
}
const styles: ComponentStylesProps<CriteriaThemeProps> = {
  formCriteriaNavBar: { marginBottom: '3rem' },
  actionButtons: {
    marginTop: 'auto',
    display: 'flex',
    gap: '2.4rem',
    justifyContent: 'center',
    [breakpoints.sm.down]: {
      '& button': {
        width: '50%',
        minWidth: 'auto',
      },
    },
  },
  backButton: {
    paddingLeft: 0,
  },
  formTemplate: ({ minHeight }) => ({
    padding: '5rem',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: minHeight || '5rem',
    [breakpoints.sm.down]: {
      padding: '4rem 2.4rem',
    },
  }),
  content: {
    marginBottom: '7rem',
    [breakpoints.sm.down]: {
      marginTop: '4rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
